import React from 'react';
import { HeadingTitle, HeaderFlexRow } from 'components/styled-components';
import colors from 'utils/colors';
import styled from 'styled-components';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';

export const QuestionnaireManagementHeader = props => (
  <>
    <HeaderFlexRow>
      <HeadingTitle>Questionnaire Management</HeadingTitle>
    </HeaderFlexRow>
    <NavWrapper>
      <QuestionNav>
        <QLink
          onClick={() => props.handleChangeActive(0)}
          className={props.active === 0 && 'active'}
        >
          Pre-Screen
        </QLink>
        <QLink
          onClick={() => props.handleChangeActive(1)}
          className={props.active === 1 && 'active'}
        >
          Questionnaire
        </QLink>
        <QLink
          onClick={() => props.handleChangeActive(2)}
          className={props.active === 2 && 'active'}
        >
          Mapping
        </QLink>
        <QLink
          onClick={() => props.handleChangeActive(3)}
          className={props.active === 3 && 'active'}
        >
          Question Archive
        </QLink>
        {hasPermission(props.appUser.permissions, [
          Permissions.VIEW_DISPLAY_CATEGORIES,
          Permissions.VIEW_QUESTION_TYPES,
        ]) && (
          <QLink
            onClick={() => props.handleChangeActive(4)}
            className={props.active === 4 && 'active'}
          >
            Manage Categories & Types
          </QLink>
        )}
      </QuestionNav>
    </NavWrapper>
  </>
);

const NavWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;

const QuestionNav = styled.div`
  text-transform: uppercase;
  padding-top: 1rem;
  overflow: auto;
`;
const QLink = styled.a`
  position: relative;
  display: inline-block;
  margin: 4px 1.5rem 4px 1rem;
  outline: none;
  color: ${colors.gray};
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 400;
  text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
  font-size: 0.9rem;
  padding: 0 0 20px;

  &::after {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 1px;
    background: ${colors.primary};
    content: '';
    opacity: 0;
    -webkit-transition: height 0.3s, opacity 0.3s, -webkit-transform 0.3s;
    -moz-transition: height 0.3s, opacity 0.3s, -moz-transform 0.3s;
    transition: height 0.3s, opacity 0.3s, transform 0.3s;
    -webkit-transform: translateY(-10px);
    -moz-transform: translateY(-10px);
    transform: translateY(-10px);
  }
  &:hover {
    outline: none;
    text-decoration: none;
    color: ${colors.primary};
  }

  &:hover::after {
    height: 4px;
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    transform: translateY(0px);
  }

  &.active::after {
    height: 4px;
    opacity: 1;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    transform: translateY(0px);
  }
  &.active {
    color: ${colors.primary};
  }
`;
